var Contact = {};

//--------------
// Variables
//--------------

Contact.$thisFormBox = null;
Contact.$form = $('.js-form-validate');

Contact.styles = [
  {
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#f5f5f5"
      }
    ]
  },
  {
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#fafafa"
      }
    ]
  },
  {
    "elementType": "labels",
    "stylers": [
      {
        "color": "#dadada"
      },
      {
        "weight": 8
      }
    ]
  },
  {
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "elementType": "labels.text",
    "stylers": [
      {
        "color": "#b9b9b9"
      },
      {
        "weight": 8
      }
    ]
  },
  {
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#b9b9b9"
      },
      {
        "visibility": "on"
      }
    ]
  },
  {
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "administrative",
    "elementType": "geometry",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "administrative.land_parcel",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "administrative.land_parcel",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#bdbdbd"
      }
    ]
  },
  {
    "featureType": "poi",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#eeeeee"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e5e5e5"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#ffffff"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#dadada"
      },
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#616161"
      }
    ]
  },
  {
    "featureType": "road.local",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  },
  {
    "featureType": "transit",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "transit.line",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e5e5e5"
      }
    ]
  },
  {
    "featureType": "transit.station",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#eeeeee"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#ececec"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  }
];


//--------------
// Functions
//--------------

/**
 * Init Google Map
 * @return {void}
 */
Contact.initMap = function(){
	// Styles a map in night mode.
  var map = new google.maps.Map(document.getElementById('map'), {
    center: {lat: 48.274844, lng: 4.031074},
    zoom: 13,
    scrollwheel: false,
    navigationControl: true,
    mapTypeControl: false,
    scaleControl: false,
    draggable: true,
    disableDefaultUI: true,
    styles: Contact.styles
  });

  var icon = {
    url: $('#map').data('marker'),
    scaledSize: new google.maps.Size(40, 40)
  };
  var marker = new google.maps.Marker({
    position: {lat: 48.257807, lng: 4.070269},
    map: map,
    icon: icon
  });
}

/**
 * Init contact scripts
 * @return {[type]} [description]
 */
Contact.init = function(){
	//-- Label display
	$('.js-form-field').on('focus', function() {
	  Contact.$thisFormBox = $(this).closest('.js-form-box');
	  console.log('focus');
	  Contact.$thisFormBox.addClass('is-active');

	}).focusout(function() {
	  if ($(this).val() === '') {
	    Contact.$thisFormBox.removeClass('is-active');
	  }
	});
}

/**
 * Destroy contact scripts
 * @return {void}
 */
Contact.destroy = function(){

}

//--------------
// Execution
//--------------

//-- Send email
$('.js-contact-form-submit').on('click', function(){
	if(Contact.$form.valid()){
    $.ajax({
      url: 'https://playground.prod.everess.fr/sendEmail.php',
      type: 'POST',
      dataType: 'JSON',
      data: {
        from_email: 'contact@everess.fr',
      	from_name: $('#contact-name').val(),
        to_email: 'contact@everess.fr',
        replyto_name : $('#contact-name').val(),
        replyto_email : $('#contact-email').val(),
        subject: 'Everess - Nouveau message',
        message : $('#contact-message').val()
      },
      success: function(data) {
      	// Reset form
        Contact.$form.find('input, textarea').each(function(){
          $(this).val("");
          $(this).closest('.js-form-box').removeClass('is-active');
        });

        $('.js-form-message-success').fadeIn();
        
        console.log('-- FORM SENT');
      },
      error : function(data) {
        $('.js-form-message-error').fadeIn();
        // alert('Une erreur est survenue, veuillez réessayer plus tard ou envoyer un mail à contact@everess.fr');
      }
    });
	}
	return false;
});

module.exports = Contact;